/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('BookSbfSlotDialogController', BookSbfSlotDialogController);

    BookSbfSlotDialogController.$inject = ['$timeout', '$scope', '$http', '$uibModalInstance', 'entity', 'AlertService', '$filter'];

    function BookSbfSlotDialogController ($timeout, $scope, $http, $uibModalInstance, entity, AlertService, $filter) {
        var vm = this;

        vm.sbfTimeSlot = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            $http.post('api/member/sbf-time-slots/book', {
                id: vm.sbfTimeSlot.id,
                comment: "test"
            }).then(onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:sbfTimeSlotUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            AlertService.success('Du hast dich erfolgreich für den Termin am <b>' + $filter('date')(vm.sbfTimeSlot.fromTime, "dd.MM.yyyy") + '</b> um <b>' + $filter('date')(vm.sbfTimeSlot.fromTime, "HH:mm") + ' Uhr</b> angemeldet.');
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fromTime = false;
        vm.datePickerOpenStatus.toTime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
